import { useEffect } from 'react';

import {
  adminActions,
  calendarDate,
  resetStatus,
  successOrSelector,
} from '@pharmaplan/common';

import { resetDrawer } from '../../actions/drawerActions';

import { useAppSelector } from '../useAppSelector';
import { useAppDispatch } from '../useAppDispatch';
import useAdminDashboard from './useAdminDashboard';
import { showSuccess } from '../../components/Admin/Profile/Pharmacist/PharmacistViewProfile/helper';
import strings from '../../localization';

const {
  deleteWorkshift,
  editAdminWorkshift,
  adminUpdateShiftContract,
  ignoreRequest,
  deletePharmacyWorkshift,
  adminRejectContract,
  adminSelfRejectContract,
  selfIgnoreRequest,
  requestCancellation,
  bookAvailablity,
  approveBooking,
  selfApproveBooking,
  adminApproveContract,
  adminDeleteContract,
  adminSelfApproveContract,
} = adminActions;

const useAdminRefresh = () => {
  const dispatch = useAppDispatch();
  const { dashBasedRequest } = useAdminDashboard();

  const cDate = useAppSelector(calendarDate);

  const actions = [
    deleteWorkshift,
    editAdminWorkshift,
    ignoreRequest,
    requestCancellation,
    bookAvailablity,
    approveBooking,
    deletePharmacyWorkshift,
    selfIgnoreRequest,
    selfApproveBooking,
    adminApproveContract,
    adminSelfApproveContract,
    adminUpdateShiftContract,
    adminRejectContract,
    adminSelfRejectContract,
    adminDeleteContract,

  ];

  // ACTIONS FOR WHICH WE WILL SHOW A SUCCESS MESSAGE
  const showDialogActions = [
    deleteWorkshift,
    editAdminWorkshift,
    adminUpdateShiftContract,
    deletePharmacyWorkshift,
    ignoreRequest,
    adminRejectContract,
    adminSelfRejectContract,
    selfIgnoreRequest,
    adminDeleteContract,
  ];

  const success = useAppSelector((state) =>
    successOrSelector(actions, state));

  const successDialog = useAppSelector((state) =>
    successOrSelector(showDialogActions, state));

  useEffect(() => {
    if (successDialog) {
      showSuccess(dispatch, strings.actionCompletedSuccessfully);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successDialog]);

  useEffect(() => {
    if (success) {
      dashBasedRequest();
      dispatch(resetStatus(actions));
      dispatch(resetDrawer());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cDate, success]);
};

export default useAdminRefresh;
